export const blockIconsNotificationLiveTv = (
	<span className='material-symbols-outlined'>live_tv</span>
);
